import { useMemo } from 'react';
import { type GoogleAdsPlacement } from '@/api/tenants/googleAdsPlacements';
import { PlacementConfigForm } from '@/components/google-ads/PlacementConfigForm';
import { InfoIconDialog } from '@/components/ui/info-icon-dialog';

const STICKY_FOOTER_PLACEMENT_KEY: GoogleAdsPlacement['placementKey'] = 'STICKY_FOOTER';

interface SquaresStickyFooterAdProps {
  placement: GoogleAdsPlacement | null;
  onPlacementChange: (placement: GoogleAdsPlacement | null) => void;
  tenantId?: string;
  isSaving?: boolean;
}

export function SquaresStickyFooterAd({
  placement,
  onPlacementChange,
  isSaving = false,
}: SquaresStickyFooterAdProps) {
  const currentPlacement = useMemo(() => {
    if (placement) return placement;

    return {
      placementKey: STICKY_FOOTER_PLACEMENT_KEY,
      enabled: false,
      sizes: [
        [320, 50],
        [728, 90],
      ] as [number, number][],
      sizeMappings: null,
      targeting: { s3: 'sticky-footer' },
    };
  }, [placement]);

  return (
    <div className="space-y-4">
      <div className="border-b pb-4 flex items-center gap-2">
        <h3 className="text-lg font-semibold">Sticky Footer Ad Placement</h3>
        <InfoIconDialog
          title="Sticky Footer Ad Placement"
          ariaLabel="Sticky footer placement information"
        >
          {`Configure the 320x50 sticky banner at the bottom of Squares views (Contests, Play, Results). Uses targeting s1, s2, s3, pid, pos. Set pos to sticky-footer for position; pid for contest ID when needed.`}
        </InfoIconDialog>
      </div>

      <PlacementConfigForm
        placement={currentPlacement}
        label="Sticky Footer Placement"
        description="320x50 ad displayed at bottom of Squares app"
        onChange={onPlacementChange}
        isSaving={isSaving}
        defaultExpanded={true}
      />
    </div>
  );
}
